var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row flex-grow" }, [
    _c("div", { staticClass: "col-lg-4 mx-auto" }, [
      _c("div", { staticClass: "auth-form-light text-left pl-5 pr-5 pb-5" }, [
        _c("div", { staticClass: "brand-logo text-right" }, [
          _c("img", {
            attrs: {
              src: "/media/aform-logo-black.png",
              alt: "Coachingclub.lu"
            }
          })
        ]),
        _vm._v(" "),
        _c("h4", [_vm._v(_vm._s(_vm.$t("pages.forgot_password.title")))]),
        _vm._v(" "),
        _c("h6", {
          staticClass: "font-weight-light",
          domProps: {
            innerHTML: _vm._s(_vm.$t("pages.forgot_password.subtitle"))
          }
        }),
        _vm._v(" "),
        _c(
          "form",
          {
            staticClass: "pt-3",
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.resetPassword($event)
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "input-group" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email"
                    }
                  ],
                  staticClass: "form-control form-control-lg",
                  class: { "is-invalid": _vm.$errors.has("email") },
                  attrs: {
                    type: "email",
                    id: "email",
                    placeholder: _vm.$t("pages.forgot_password.email")
                  },
                  domProps: { value: _vm.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.email = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("error", { attrs: { input: "email" } })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-block btn-outline-dark btn-lg font-weight-medium auth-form-btn"
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("pages.forgot_password.reset_password")) +
                      "\n                    "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "my-2 d-flex justify-content-between align-items-center"
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "auth-link text-black",
                    attrs: { to: { name: "login" } }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("pages.forgot_password.login")) +
                        "\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "font-weight-light" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("pages.login.dont_have_an_account")) +
                      " "
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "text-primary",
                      attrs: { href: "register.html" }
                    },
                    [_vm._v(_vm._s(_vm.$t("pages.login.create_account")))]
                  )
                ])
              ],
              1
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }